<script>
import Loader from '@components/loader.vue'

export default {
  components: { Loader },
}
</script>

<template>
  <button :class="$style.button" v-bind="$attrs" v-on="$listeners">
    <Loader v-if="$attrs.loading" />
    <slot v-else />
  </button>
</template>

<style lang="scss" module>
@import '@design';

.button {
  @extend %font-heading;

  background: var(--color-primary);
  border: none;
  color: var(--color-white);
  cursor: pointer;
  display: inline-block;
  letter-spacing: 1.2px;
  min-width: 240px;
  outline: 0;
  padding: $size-button-padding;
  text-transform: uppercase;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.2;
  }
}
</style>
